import React from 'react';
import SkeletonLoader from './SkeletonLoader';

const BrandsPageSkeleton = () => {
  return (
    <div className="main-content-container brands-page">
      {/* Titolo centrato */}
      <div className="skeleton-brands-title skeleton-loader"></div>
      
      {/* Searchbar centrata */}
      <div className="brands-searchbar-wrapper">
        <div className="skeleton-brands-searchbar skeleton-loader"></div>
      </div>
      
      {/* Lista delle sezioni per lettera */}
      <div className="brands-list">
        {[...Array(4)].map((_, sectionIndex) => (
          <div key={sectionIndex} className="brands-letter-section">
            {/* Header della lettera */}
            <div className="brands-letter-header">
              <div className="skeleton-brands-letter-header skeleton-loader"></div>
            </div>
            
            {/* Grid dei brand */}
            <div className="brands-grid">
              {[...Array(8)].map((_, brandIndex) => (
                <div key={brandIndex} className="skeleton-brand-link skeleton-loader"></div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BrandsPageSkeleton; 